import React, { ChangeEvent, useEffect, useState, useRef, useCallback} from "react";
import {FolderInformation } from "../../../model/ItemModel";

export function GetDragPermission(currentFolder? : FolderInformation)
{
    return currentFolder?.permissionType == 1 || currentFolder?.permissionType == 3;
}